import React from "react";
import { CustomModal } from "../Common/Modal/CustomModal";
import { DateFormatConstants, FileViewDetailsModalConstants } from "src/Core/Common/Constants";
import { IMyFilesFileModel } from "src/Core/ViewModels/File/MyFilesFileModel";
import { getFormattedLocalDateTime } from "src/helper/DateHelperFunctions";
import { MyFilesFileType } from "src/Core/Common/Enums";
import { formatBytes } from "src/helper/HelperFunctions";

interface IFileDetailPopupProps {
    show: boolean;
    file: IMyFilesFileModel;
    onHide: () => void;
}

export const FileDetailPopup: React.FC<IFileDetailPopupProps> = ({ show, file, onHide }) => {
    const isDocumentRequest = file.fileType === MyFilesFileType.DocumentRequest;
    const subject = isDocumentRequest ? "NA" : file.subject;
    const documentName = isDocumentRequest ? file.documentName ?? "-" : "NA";
    const documentCategory = isDocumentRequest ? file.documentCategory ?? "-" : "NA";
    const uploadedBy = isDocumentRequest ? file.uploadedBy ?? "-" : "NA";
    const uploadedDate = isDocumentRequest
        ? file.uploadedDate != null
            ? getFormattedLocalDateTime(file.uploadedDate, DateFormatConstants.DEFAULT_DATE_FORMAT)
            : "-"
        : "NA";
    const lastDownload = file.lastDownload ? getFormattedLocalDateTime(file.lastDownload, DateFormatConstants.FILE_DETAILS_LAST_DOWNLOAD_DATE_FORMAT) : "NA";
    const size = formatBytes(Number(file.size));
    const sender = file.senderFirstName || file.senderLastName ? `${file.senderFirstName} ${file.senderLastName}` : "NA";
    const sentOrReceivedDate = file.fileType === MyFilesFileType.ReceivedMessage || file.fileType === MyFilesFileType.SentMessage
        ? file.sentOrReceivedDate != null
            ? getFormattedLocalDateTime(file.sentOrReceivedDate, DateFormatConstants.DEFAULT_DATE_FORMAT) : "-"
        : "NA";
    const expireDate = file.expireDate != null ? getFormattedLocalDateTime(file.expireDate, DateFormatConstants.DEFAULT_DATE_FORMAT) : "-";

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            isConfirmModal={true}
            cancelButtonName="Close"
            className="files-details-modal"
            title={FileViewDetailsModalConstants.MODAL_TITLE}
            backdrop="static"
        >
            <div className="files-details-container">
                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.FILE_NAME}:
                    </label>
                    <span title={file.fileName} className="files-details-value">{file.fileName}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.SUBJECT}:
                    </label>
                    <span title={file.subject} className="files-details-value">{subject}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.DOCUMENT_NAME}:
                    </label>
                    <span title={documentName} className="files-details-value">{documentName}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.DOCUMENT_CATEGORY}:
                    </label>
                    <span title={documentCategory} className="files-details-value">{documentCategory}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.LAST_DOWNLOAD}:
                    </label>
                    <span title={lastDownload} className="files-details-value">{lastDownload}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.SIZE}:
                    </label>
                    <span title={size} className="files-details-value">{size}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.SENDER}:
                    </label>
                    <span title={sender} className="files-details-value">{sender}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.SENT_RECEIVED_DATE}:
                    </label>
                    <span title={sentOrReceivedDate} className="files-details-value">{sentOrReceivedDate}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.UPLOADED_BY}:
                    </label>
                    <span title={uploadedBy} className="files-details-value">{uploadedBy}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.UPLOADED_DATE}:
                    </label>
                    <span title={uploadedDate} className="files-details-value">{uploadedDate}</span>
                </span>

                <span className="files-details-row">
                    <label className="files-details-label">
                        {FileViewDetailsModalConstants.EXPIRE_DATE}:
                    </label>
                    <span title={expireDate} className="files-details-value">{expireDate}</span>
                </span>
            </div>
        </CustomModal>
    );
};

export default FileDetailPopup;